import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Markdown from "markdown-to-jsx";
import Container from "src/react/layout/container";
import { ContentSection } from "../styles";

function ContentBlock({ children }) {
  return (
    <Container>
      <CustomContentSection data-selector="ContentBlock">
        <Markdown>{children}</Markdown>
      </CustomContentSection>
    </Container>
  );
}

export default ContentBlock;

ContentBlock.propTypes = {
  children: PropTypes.any,
};

const CustomContentSection = styled(ContentSection)`
  margin-bottom: 40px;
  h2 {
    font-size: 22px;
    @media (min-width: 768px) {
      font-size: 24px;
    }
  }
  h3 {
    margin-bottom: 5px;
  }
  h2,
  h3 {
    :not(:first-child) {
      margin-top: 40px;
    }
  }
`;
